/* Copyright (c) 2022-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { isEmpty } from "./size";

function concatText(entry: string, text: string) {
  return isEmpty(text) ? entry : entry.concat(" ", text);
}

export function generateActionSuccessText(item: string) {
  return (verb = "has") => {
    return (action: string) => {
      return (rest = "") => {
        const baseText = `${item} ${verb} been ${action}`;
        return `${concatText(baseText, rest)}.`;
      };
    };
  };
}

export const formatText = (s?: string): string => {
  if (!s) {
    return "";
  }

  const lowerCased = s.toLowerCase().replace("_", "\u00a0");

  return `${lowerCased.charAt(0).toUpperCase()}${lowerCased.slice(1)}`;
};
